import axios from "axios";
import {UserAuthService} from "./user-auth-api.service";
import {notification} from "antd";
import {ERROR_CODE} from "../utils/constant";
import {CloseRoundedCheck} from "../../assets/icons/defaultIcons";
import React from "react";

/**
 * This file doesn't do much. It's just a wrapper for axios that only exists to:
 * 1 - Set the base URL on axios from environment vars
 * 2 - Stuff the `Authorization` header in before a request goes out
 */
axios.defaults.baseURL = process.env.REACT_APP_AUTH_API_BASE_URL;
// axios.defaults.baseURL = "http://localhost:8000/api/v1/"

// const ERROR_CODE = BACKEND_CONSTANTS.ERROR_CODE;
// Secondary usage of axios in case we need one without auth headers .. i.e. for login.
export const axiosService = axios;
// Export our custom axios instance with auth headers added
export const authApi = axios.create({
    // baseURL: "/api",
    timeout: 60 * 1000,
});

authApi.interceptors.request.use(
    (config) => {
        let token = UserAuthService.getToken();
        return {
            ...config,
            headers: {
                ...config.headers,
                Authorization: `Bearer ${token}`,
                is_web_agent : "true"
            },
        };
    },
    (exc) => Promise.reject(exc)
);
authApi.interceptors.response.use(
    (res) => {
        return {
            data: {
                data: res.data,
                status: res.data.success ?? res.data.status, // true or false
                message: res.data.message,
            },
        };
    },
    (err) => {
        console.log("ERRR", err?.response?.data?.message);
        const errorMsg = 'Something went wrong';
        switch (err?.response?.status) {
            case ERROR_CODE.UN_AUTHORIZED:
                notification.error({
                    message: "Failed",
                    description: `${err.response?.data?.message}`,
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
                // toast.error(errorMsg);
                UserAuthService.logout();
                break;
            default:

                notification.error({
                    message: "Failed",
                    description: err.response?.data?.message || errorMsg,
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            // toast.error(errorMsg);
        }
        return {
            data: {
                status: false,
                message: errorMsg,
                data: null,
            },
        };
    }
);
